export const fetchVisitorStats = async (propertyId, period = '7d') => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/analytics/stats?propertyId=${propertyId}&period=${period}`);
    const data = await res.json();
    if (data.success) return data.stats;
    throw new Error('Failed to fetch stats');
  } catch (error) {
    console.error("Analytics API error:", error);
    return [];
  }
};
export const fetchSessionMedium = async (propertyId, period = '7d') => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/analytics/session-medium?propertyId=${propertyId}&period=${period}`);
    const data = await res.json();
    if (data.success) return data.data;
    throw new Error('Failed to fetch session medium');
  } catch (error) {
    console.error("Session Medium API error:", error);
    return [];
  }
};
export const fetchOverviewAnalytics = async ({ propertyId, period = '7d' }) => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/analytics/overview?propertyId=${propertyId}&period=${period}`);
    const data = await res.json();
    if (data.success) return data.data;
    throw new Error('Failed to fetch overview analytics');
  } catch (error) {
    console.error("Overview Analytics API error:", error);
    return { stats: {}, chart: [] };
  }
};

export const fetchRealtimeUsers = async (propertyId) => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/analytics/realtime-users?propertyId=${propertyId}`);
    const data = await res.json();
    return data.count || 0;
  } catch (error) {
    console.error("Realtime Users API error:", error);
    return 0;
  }
};
// analyticsApi.js
export const fetchUsersPerMinute = async (propertyId) => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/analytics/users-per-minute?propertyId=${propertyId}`);
    const data = await res.json();
    return data.data || [];
  } catch (error) {
    console.error("Users per minute API error:", error);
    return [];
  }
};

export const fetchTopActiveCountries = async (propertyId) => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/analytics/top-active-countries?propertyId=${propertyId}`);
    const data = await res.json();
    if (data.success) return data.data;
    throw new Error('Failed to fetch top active countries');
  } catch (error) {
    console.error("Top Active Countries API error:", error);
    return [];
  }
};
export const fetchDeviceStats = async (propertyId) => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/analytics/device-stats?propertyId=${propertyId}`);
    const data = await res.json();
    if (data.success) return data.data;
    throw new Error('Failed to fetch device stats');
  } catch (error) {
    console.error("Device Stats API error:", error);
    return [];
  }
};

export const fetchTrafficSources = async (propertyId, period = '7d') => {
  const res = await fetch(
    `${process.env.REACT_APP_API_URL}/api/analytics/traffic-sources?propertyId=${propertyId}&period=${period}`
  );
  const json = await res.json();
  return json.data || [];
};

export const fetchAllSessionMedium = async (propertyId, period = '7d') => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/analytics/session-medium/all?propertyId=${propertyId}&period=${period}`);
    const data = await res.json();
    if (data.success) return data.data;
    throw new Error('Failed to fetch all session medium');
  } catch (error) {
    console.error("All Session Medium API error:", error);
    return [];
  }
};